export default {
  profile: 'Perfil',
  logout: 'Deslogar',
  selectProfiles: 'Seleção de perfis'
}
